import React, { ReactElement } from "react";

export interface IButtonPrimary {
  children: string | ReactElement;
  onClick?: any;
  disabled?: boolean;
}

export default function ButtonPrimary(props: IButtonPrimary) {
  return (
    <button
      onClick={props.disabled ? undefined : props.onClick}
      disabled={props.disabled}
      className={`rounded-3xl w-full text-large font-medium text-brij-White ${
        props.disabled 
          ? 'bg-gray-400 cursor-not-allowed' 
          : 'bg-brij-Peach hover:bg-brij-PeachDark'
      } inline-flex justify-center px-10 py-4`}
    >
      {props.children}
    </button>
  );
}
